module.exports = __webpack_public_path__ + "img/jwc.e2aaf98c.png";